/** @jsx jsx */

import React, { useRef, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import EditorBtn from 'components/UI/EditorBtn';
import { colors } from 'styles/variables';
import getStore from 'services/getStore';

interface IFileUploader {
  label: string;
  onUploadStart?: any;
  onUploadComplete: (result: { [key: string]: any }, e: any) => void;
  btnColor?: string;
  style?: { [key: string]: any };
}

const store = getStore();
const { lPink, lGrey0, lGrey1 } = colors;

const onFileSelected = (e, onUploadComplete) => {
  e.persist();

  const { projectId } = store.getState();

  window.client.files
    .set(e.target.files, projectId)
    .then(d => {
      onUploadComplete(d, e);
    })
    .catch(error => onUploadComplete(error, e));
};

const FileUploader = ({
  label,
  onUploadStart,
  onUploadComplete,
  btnColor = lGrey0,
  style = {},
  ...props
}: IFileUploader) => {
  // const { projectId } = store.getState();
  const fileUpload = useRef<HTMLInputElement>(null);

  return (
    <div>
      <EditorBtn
        label={label}
        css={css`
          padding-left: 30px;
          padding-right: 30px;
          background: ${btnColor};
        `}
        style={style}
        onClick={() => {
          onUploadStart && onUploadStart();
          fileUpload.current!.click();
        }}
        {...props}
      />
      <input
        ref={fileUpload}
        type="file"
        id="file-upload"
        style={{ display: 'none' }}
        onChange={e => {
          // window.client.files
          //   .set(e.target.files, projectId)
          //   .then(d => {
          //     onUploadComplete(d);
          //   })
          //   .catch(error => onUploadComplete(error));
          onFileSelected(e, onUploadComplete);
        }}
      />
    </div>
  );
};

function rawUploader(files, onUploadComplete) {
  const { projectId } = store.getState();

  const FileList = {
    0: files[0],
    length: 1,
  };

  console.log(FileList);

  window.client.files
    .set(FileList, projectId)
    .then(d => {
      onUploadComplete(d);
    })
    .catch(error => onUploadComplete(`ERROR : ${error}`));
}

export default FileUploader;
export { onFileSelected, rawUploader };
